<template>
  <div id="top-reviews-carousel" :class="{'is-visible': isFreeSubscriptionActive}">
    <template>
      <div class="level">
        <div class="level-left">
          <p class="has-text-weight-bold is-size-5">What our customers say:</p>
        </div>
        <div class="level-right"><img src="/static/img/logo/powered-by-hp.png" srcset="/static/img/logo/powered-by-hp@2x.png 2x" /></div>
      </div>
      <hr/>
      <img v-if="fetching" class="loader" src="/static/img/loaders/spinner.svg" alt="fetching top reviews..." />
      <carousel v-if="!fetching" :navigation-enabled="navigationEnabled" :pagination-enabled="paginationEnabled" :per-page="reviewsPerPage" :scroll-per-page="scrollPerPage">
        <slide v-for="record in reviewList" :key="record.id">
          <div class="columns">
            <div class="column"><rating :stars="record.review_rating" :reviews-widget="tinyStars"></rating></div>
          </div>
          <div class="columns">
            <div class="column">
              <h4 class="has-text-weight-bold">{{ record.review_title | snippetTitle }}</h4>
              <p v-html="snippetCopy(record.review_content, record.permalink)"></p>
              <p class="author"><span v-text="record.author"></span>&nbsp;|&nbsp;{{ record.created_date | reviewDate }}</p>
            </div>
          </div>
        </slide>
      </carousel>
    </template>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import Rating from './../components/Rating.vue'
  import ReviewsWidgetMixin from './../mixins/reviews-widget.js'
  import misc from './../mixins/misc.js'

  export default {
    name: 'TopReviewsCarousel',
    props: {
      slug: {
        type: String
      },
      reviewsPerPage: {
        type: Number,
        default: 3
      }
    },
    mixins: [ReviewsWidgetMixin, misc],
    components: {
      Rating
    },
    data () {
      return {
        navigationEnabled: true,
        paginationEnabled: false,
        // reviewsPerPage: 3,
        scrollPerPage: false
      }
    },
    created () {
      this.getReviewFeed()
      this.getCurrentBusinessActiveSubscription()
    },
    filters: {
      snippetTitle (text) {
        if (text.length > 21) {
          return text.substring(0, 22).trim() + '...'
        }
        return text
      }
    },
    methods: {
      snippetCopy (text, permalink) {
        if (text.length > 99) {
          const newText = text.substring(0, 100).trim()
          return `${newText}...<a class="external-link" href="${this.externalUrl(permalink)}" target="_blank">read&nbsp;more</a>`
        }
        return text
      }
    }
  }
</script>
<style scoped>
  #top-reviews-carousel {
    border-top: 4px solid #2FABE1;
    width: 900px;
    height: 317px;
    padding: 30px;
    color: #58595B;
  }

  #top-reviews-carousel img {
    display: block;
    width: 156px;
    height: 20px;
  }

  #top-reviews-carousel img.loader {
    width: 40px;
    height: 40px;
    float: none;
    display: block;
    margin: auto;
    border:none;
  }

  #top-reviews-carousel hr {
    background-color: #DFDFE0;
  }

  #top-reviews-carousel .VueCarousel-slide > .columns:first-child {
    margin-bottom: 0.2rem;
  }

  #top-reviews-carousel h4 {
    font-size: 1rem;
    margin-bottom: 0.4rem;
  }

  #top-reviews-carousel .VueCarousel-slide > .columns:nth-child(2) > .column > p {
    font-size: 0.8rem;
  }

  #top-reviews-carousel .VueCarousel-slide > .columns:nth-child(2) > .column > p.author {
    color: #8A8C91;
    font-size: 0.7rem;
    margin-top: 1rem;
  }

  #top-reviews-carousel .VueCarousel-slide {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }

  #top-reviews-carousel span {
    font-weight: bold;
  }

  #top-reviews-carousel a {
    text-decoration: underline!important;
    color: #30AAE1!important;
  }

  div#top-reviews-carousel .level {
    margin-bottom: 5px !important;
  }

  div#top-reviews-carousel .level~hr {
    margin: 0px 39px 0px 35px;
  }

  #top-reviews-carousel .VueCarousel-slide > .columns {
    margin-top: 0px;
    margin-bottom: 0px !important;
    clear: both;
    float: left;
    width: 100%;
    margin: 0px;
  }
  #top-reviews-carousel .level-left {
    margin-left: 28px;
  }

  #top-reviews-carousel .level-right {
    margin-right: 39px;
  }

  #top-reviews-carousel h4[data-v-6fe7d8c2] {
    font-size: 1rem;
    margin-bottom: 0.4rem;
  }

  #top-reviews-carousel h4 {
    font-size: 14px !important;
  }

  #top-reviews-carousel .VueCarousel-slide > .columns:nth-child(2) {
    margin-top: -1.1rem;
    margin-left: 0px;
    margin-right: 0px;
  }


  #top-reviews-carousel .VueCarousel-navigation-button {
    top: 61% !important;
  }

  div#top-reviews-carousel .VueCarousel-navigation-prev {
    -webkit-transform: translateY(-165%) translateX(-100%);
    transform: translateY(-165%) translateX(-100%);
  }

  div#top-reviews-carousel .VueCarousel-navigation-next {
    -webkit-transform: translateY(-165%) translateX(100%);
    transform: translateY(-165%) translateX(100%);
  }
  div#top-reviews-carousel p.is-size-5 {
    font-size: 18px !important;
  }

</style>
<style>
  .VueCarousel .VueCarousel-navigation-button.VueCarousel-navigation-prev:before, .VueCarousel .VueCarousel-navigation-button.VueCarousel-navigation-next:before {
    content: "<";
    position: absolute;
    top: 10px;
    left: 4px;
    color: #cccccc;
    font-size: 50px;
    height: 100%;
    width: 100%;
    display: inline-block;
    font-weight: 100;
    background: url('/static/img/left-arrow-icon.png');
    background-repeat: no-repeat;
    content: '';

  }

  .VueCarousel .VueCarousel-navigation-button.VueCarousel-navigation-next:before {
    content: ">";
    left: -4px;
  }
  div#top-reviews-carousel .VueCarousel-navigation-next:before {
    background: url('/static/img/right-arrow-icon.png');
    background-repeat: no-repeat;
    content: '';
  }

  .VueCarousel-navigation-button{font-size:0px;width:24px;height:36px;}
  #top-reviews-carousel{
    background: #fff;
    border: 1px solid #ccc;
    border-top: 1px solid #ccc !important;
    margin-bottom: 30px;
    margin: auto;
    height: auto !important;
    padding: 10px 30px !important;
  }
  .width-80-percent #top-reviews-carousel .level:not(:last-child) {
    margin-bottom: 5px !important;
  }
  div#top-reviews-carousel .VueCarousel-navigation-prev {
    -webkit-transform: translateY(-165%) translateX(-100%);
    transform: translateY(-165%) translateX(-100%);
  }

  div#top-reviews-carousel .VueCarousel-navigation-next {
    -webkit-transform: translateY(-165%) translateX(100%);
    transform: translateY(-165%) translateX(100%);
  }
  #top-reviews-carousel .VueCarousel-navigation-button {
    top: 61% !important;
  }
  #top-reviews-carousel a.external-link {
    text-decoration: underline !important;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/TopReviewsCarousel.vue